<template>
  <div>

    <!-- <v-row class="mb-16">
      <v-col cols="12" md="12"> -->
    <!-- <v-card-title class="text-h4 font-weight-bold mb-4">
      {{ $t('products.title') }}
    </v-card-title> -->
    <!-- 
      </v-col>
      <v-col cols="12">
        <template> -->
    <v-card color="" elevation="0" class="">
      <v-divider></v-divider>
      <template>
        <v-tabs color="primary" v-model="tabs" class=" " height="80" background-color="#f4f4f4">
          <div class="d-flex align-center px-4  ">
            <v-icon color="primary" class="" size="">mdi-package-variant-closed</v-icon>
      <h5 class="font-weight-bold headline ml-2">      {{ $t('products.title') }}</h5>
      
      </div>
          <v-tab class="ml-4"> {{ $t('products.ASUS.stepTitle') }}</v-tab>
          <v-tab> {{ $t('products.packages.stepTitle') }}</v-tab>
          <v-tab>Sessões personalizadas</v-tab>

          <!-- <v-tab disabled>{{ $t('products.ASUS.prices') }}</v-tab>
          <v-chip x-small class="mb-2 mt-2 px-1 ml-n3" color="info"><span class="black---text">{{ $t('products.ASUS.underDev') }}</span></v-chip>
          <v-tab disabled>{{ $t('products.ASUS.ratings') }}</v-tab>
          <v-chip x-small class="mb-2 mt-2 px-1 ml-n3" color="info"><span class="black---text">{{ $t('products.ASUS.underDev') }}</span></v-chip> -->
        </v-tabs>
      </template>
      <v-tabs-items v-model="tabs">
  
        <v-tab-item><AsusList :type="'common-list'"></AsusList></v-tab-item>
        <v-tab-item><PackagesList></PackagesList></v-tab-item>
        <v-tab-item><SessionsList></SessionsList></v-tab-item>
        <v-tab-item></v-tab-item>
        <v-tab-item></v-tab-item>

      </v-tabs-items>
    </v-card>
    <!-- </template>
      </v-col>

    </v-row>-->
  </div>
</template>

<script>
// import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import AsusList from '@/components/products/AsusList'
import PackagesList from '@/components/products/PackagesList';
import SessionsList from '@/components/products/SessionsList.vue'

export default {
  name: "ProductsTable",
  components: {
    AsusList,
    PackagesList,
    SessionsList
},
  data() {
    return {
      tabs: 0,
     
    };
  },
  mounted() {
    this.loadTabs()
  },
  watch: {
    '$route.params.tab'(){
      this.loadTabs()
    },
    'tabs'(nV){
      let query = []
      for(let key in this.$route.query){
        if(nV != 0 && key == 'q')
        query.push(`${key}=${this.$route.query[key]}`)
      }
      const qstring = query.length ? `?${query.join('&')}` : ''
      
      if(nV == 0 && this.$route.fullPath != `/products/asus${qstring}`)
      this.$router.replace(`/products/asus${qstring}`)
      if(nV == 1 && this.$route.path != '/products/packages')
        this.$router.replace(`/products/packages${qstring}`)
         
    }
  },
  methods: {
    loadTabs() {
      if (!this.$route.params.tab) {
        this.tabs = 0
      }
      else {
        if (this.$route.params.tab == 'asus') {
          this.tabs = 0
        }
        if (this.$route.params.tab == 'packages') {
          this.tabs = 1
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>